/**
 * Jira Logo SVG Component
 *
 * Atlassian Jira brand logo
 */

interface JiraLogoProps {
  className?: string;
}

export function JiraLogo({ className }: JiraLogoProps) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient
          id="jira-gradient-1"
          x1="17.39"
          y1="3.39"
          x2="10.8"
          y2="10.21"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0052CC" stopOpacity="0" offset="0" />
          <stop stopColor="#0052CC" offset="0.92" />
        </linearGradient>
        <linearGradient
          id="jira-gradient-2"
          x1="15.1"
          y1="15.6"
          x2="8.25"
          y2="22.62"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0052CC" stopOpacity="0" offset="0" />
          <stop stopColor="#0052CC" offset="0.92" />
        </linearGradient>
      </defs>
      {/* Top-right square */}
      <path
        d="M15.52 2C15.52 4.87 17.88 7.22 20.75 7.22H22.88V9.25C22.88 12.12 25.22 14.47 28.09 14.48V3.17C28.09 2.52 27.57 2 26.92 2H15.52Z"
        fill="#2684FF"
      />
      {/* Middle square */}
      <path
        d="M10.77 6.8C10.76 9.69 13.12 12.05 16.01 12.06H18.16V14.07C18.15 16.96 20.49 19.32 23.38 19.34V8C23.38 7.34 22.85 6.81 22.2 6.8H10.77Z"
        fill="url(#jira-gradient-1)"
      />
      <path
        d="M10.77 6.8C10.76 9.69 13.12 12.05 16.01 12.06H18.16V14.07C18.15 16.96 20.49 19.32 23.38 19.34V8C23.38 7.34 22.85 6.81 22.2 6.8H10.77Z"
        fill="#2684FF"
      />
      {/* Bottom-left square */}
      <path
        d="M6 11.6C6 14.49 8.36 16.85 11.25 16.86H13.38V18.88C13.38 21.76 15.72 24.12 18.61 24.14V12.77C18.61 12.12 18.08 11.59 17.43 11.6H6Z"
        fill="url(#jira-gradient-2)"
      />
      <path
        d="M6 11.6C6 14.49 8.36 16.85 11.25 16.86H13.38V18.88C13.38 21.76 15.72 24.12 18.61 24.14V12.77C18.61 12.12 18.08 11.59 17.43 11.6H6Z"
        fill="#2684FF"
      />
    </svg>
  );
}
